import {
  Avatar,
  Badge,
  Box,
  Checkbox,
  HStack,
  Icon,
  IconButton,
  Table,
  Image,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Stack,
  Tooltip,
  Tr,
} from "@chakra-ui/react";
import { InfoOutlineIcon } from "@chakra-ui/icons";

import * as React from "react";
import { FiEdit2, FiInfo } from "react-icons/fi";
import { IoArrowDown } from "react-icons/io5";
import {
  FaInstagram,
  FaTiktok,
  FaMailBulk,
  FaSnapchatGhost,
} from "react-icons/fa";
import { KYDAdminEvent, KYDAdminCampaign } from "@common/interfaces/KYDEvent";
import {
  AdminTicketType,
  KYDTicketType,
  TicketTypeStatus,
} from "@common/interfaces/KYDTicket";
import { KYDMarketingPlatform } from "@common/interfaces/KYDOrganization";

export const CampaignsTable = ({
  kydEvent,
  ...props
}: {
  kydEvent: KYDAdminEvent;
}) => {
  const badgeForStatus = (ticketType: KYDTicketType) => {
    let bg = "gray";
    let name = "N/A";

    if (ticketType.sold_out) {
      bg = "orange";
      name = "Sold Out";
    } else {
      switch (ticketType.status) {
        case "DRAFT":
          bg = "blue";
          name = "Draft";

          break;
        case "PROCESSING":
          bg = "yellow";
          name = "Processing";

          break;
        case "OPEN":
          bg = "green";
          name = "On Sale";

          break;
        case "OFFSALE":
          bg = "red";
          name = "Off Sale";

          break;
        default: {
        }
      }
    }

    return (
      <Box>
        <Badge
          justifyItems={"center"}
          maxW={"100px"}
          size={"xl"}
          colorScheme={bg}
        >
          {name}
        </Badge>
        {ticketType.status === "OPEN" && ticketType.display_off_sale_at ? (
          <Text fontSize={"xs"} color={"gray.500"}>
            Off sale {ticketType.display_off_sale_at}
          </Text>
        ) : null}
        {ticketType.status === "OFFSALE" && ticketType.display_on_sale_at ? (
          <Text fontSize={"xs"} color={"gray.500"}>
            On sale {ticketType.display_on_sale_at}
          </Text>
        ) : null}
      </Box>
    );
  };

  const platformIcon = (platform: KYDMarketingPlatform) => {
    if (platform === "email") {
      return <FaMailBulk size={"20px"} />;
    } else if (platform === "meta") {
      return <FaInstagram size={"20px"} />;
    } else if (platform === "snapchat") {
      return <FaSnapchatGhost size={"20px"} />;
    } else if (platform === "tiktok") {
      return <FaTiktok size={"20px"} />;
    }
  };

  return (
    <Table {...props}>
      <Thead>
        <Tr>
          <Th></Th>
          <Th>Name</Th>
          <Th>Impressions</Th>
          <Th>Spend</Th>
          <Th>Sales</Th>
          <Th>ROAS</Th>
          <Th>Tickets</Th>
          <Th>CTR</Th>
          <Th>Clicks</Th>
          <Th></Th>
        </Tr>
      </Thead>
      <Tbody>
        {kydEvent.campaigns &&
          kydEvent.campaigns.map((campaign: KYDAdminCampaign) => (
            <Tr key={campaign.campaign_id}>
              <Td>{platformIcon(campaign.platform)}</Td>
              <Td>
                <Text>{campaign.campaign_name}</Text>
              </Td>
              <Td>
                <Text>{campaign.display_impressions}</Text>
              </Td>
              <Td>
                <Text>{campaign.display_spend}</Text>
              </Td>
              <Td>
                <Text>{campaign.display_ticket_gmv}</Text>
              </Td>
              <Td>
                <Text>{campaign.display_kyd_roas}</Text>
              </Td>
              <Td>
                <Text>{campaign.display_ticket_count}</Text>
              </Td>
              <Td>
                <Text>{campaign.display_ctr}</Text>
              </Td>
              <Td>
                <Text>{campaign.display_clicks}</Text>
              </Td>
            </Tr>
          ))}
      </Tbody>
    </Table>
  );
};
